/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Error_AuthInputs */



/**
* | output |
* | --- |
* | "Authentication with the AI provider failed. Please check your provider configuration." |
*
* @param {Chat_Error_AuthInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_error_auth = /** @type {((inputs?: Chat_Error_AuthInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Error_AuthInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Authentifizierung beim KI-Anbieter ist fehlgeschlagen. Bitte überprüfe deine Anbieter-Konfiguration.")
	return /** @type {LocalizedString} */ ("Authentication with the AI provider failed. Please check your provider configuration.")
});